import React, { Fragment, useState } from 'react';
import classNames from 'classnames';

import {
  PaymintsButton,
  BUTTON_TYPE,
} from 'paymints-address-autocomplete-field';
import { withRouter } from 'react-router-dom';
import { getClientStore } from '../../utils/util';
import './boxContainerWiring.css';
import split from 'lodash/split';
import get from 'lodash/get';
import {
  useAllTenants,
  useAllBrandingsFromTenant,
  useDefaultBrandingFromTenant,
} from '../../utils/service/service_tenant_api';
import { getQueryVariable } from '../../utils/util';
import sideImage from '../../styles/assets/bg.png';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Logo } from './Logo';
import { createLogButton } from './lib/createLogButton';
import css from '../../styles/modules/WiringInstructions/boxcontainerwiring.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearLoading,
  setLoading,
} from '../../reducers/utility/utilityActions';
import useWindowWidth from '../../hooks/nonGQLhooks/useWindowWidth';

const BoxContainerWiring = ({
  children,
  className = '',
  color = 'default',
  withBorder = true,
  withDoubleBorder = false,
  withLogButton = false,
  widest = false,
  internalBox = false,
  history,
  showLogin = false,
  detail,
  tenantName,
  transfer_detail,
}) => {
  const { user } = getClientStore();
  const tenantIdentifier = split(window.location.hostname, '.')[0];
  const { tenant } = useAllTenants(tenantIdentifier);
  const { branding } = useAllBrandingsFromTenant(get(tenant, '_id', ''), true);

  const { defaultBranding } = useDefaultBrandingFromTenant();
  const windowWidth = useWindowWidth();
  const brandLogo = branding
    ? get(branding, 'logoURL')
    : get(defaultBranding, 'logoURL');
  const path = window.location.search.split('?')[2];
  const selectedTab = getQueryVariable(path, 'disbursement') || null;
  const classNameBox = classNames(
    `paymints__box-container-wiring paymints__box-container-wiring${
      internalBox ? '__internal' : ''
    }--${color} ${className}`,
    {
      'with-border': withBorder,
    },
  );
  const classNameContainer = classNames(
    `paymints__box-container-wiring__container paymints__box-container-wiring__box-shadow--default`,
    {
      widest: widest,
    },
  );

  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state).utility;

  function onExit() {
    if (!isLoading) {
      dispatch(setLoading(true));

      //transition delayed to allow loading spinner to render.
      setTimeout(() => {
        dispatch(clearLoading());
        history.push('/transfer-history');
      }, 100);
    }
  }

  if (withDoubleBorder) {
    return (
      <>
        {
          <div
            style={{
              display: 'flow-root',
              gridTemplateColumns: '65% 35%',
              backgroundColor: '#fff',
            }}
          >
            <div className="d-flex">
              <div className={classNameContainer}>
                <div className="paymints__box-container-wiring__box-shadow">
                  <div className={css.topContainer}>
                    <div className={css.logoContainer}>
                      <img className={css.brandLogo} src={brandLogo} />
                      {/* <p
                        className={css.breadCrumb}
                      >{`Payments > Send Money`}</p> */}
                    </div>
                  </div>
                  <div className={classNameBox}>{children}</div>
                </div>
              </div>
              <div
                style={windowWidth <= 1024 ? { display: 'none' } : null}
                className="grey-bg earn-money-deposite text-left"
              >
                <h4 className="light-grey">Transaction Details</h4>
                <div className="text-box mt-5 mb-5">
                  <button
                    className="btn-purple"
                    style={{ pointerEvents: 'none' }}
                  >
                    <svg
                      width="18"
                      height="13"
                      viewBox="0 0 18 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.54961 13L0.849609 7.29998L2.27461 5.87498L6.54961 10.15L15.7246 0.974976L17.1496 2.39998L6.54961 13Z"
                        fill="white"
                      />
                    </svg>
                    {transfer_detail?.purpose}
                  </button>
                </div>
                <div className="text-box">
                  <h6 className="light-grey">Amount</h6>
                  <b>
                    $
                    {parseFloat(transfer_detail?.amount).toLocaleString(
                      'en-US',
                      { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                    )}
                  </b>
                </div>
                <div className="text-box">
                  <h6 className="light-grey">Property Address</h6>
                  <b>
                    {' '}
                    {transfer_detail?.propertyAddress1} <br />
                    {transfer_detail?.propertyCity},{' '}
                    {transfer_detail?.propertyState}
                  </b>
                </div>
                <div className="text-box">
                  <h6 className="light-grey">Notes</h6>
                  <b className="custom-font">{transfer_detail?.notes}</b>
                </div>
                <div className="text-box">
                  <h6 className="light-grey">Sending to </h6>
                  <b>{tenantName}</b>
                </div>
              </div>
            </div>
          </div>
        }
      </>
    );
  }

  return (
    <div className={classNameBox}>
      <div>
        {withLogButton &&
          createLogButton(user, brandLogo, history, showLogin, branding)}
        {children}
      </div>
    </div>
  );
};

export default withRouter(BoxContainerWiring);
